// Makes every react-hot-toast toast in the app follow the user's theme.
// Imported ONCE in index.js — no page needs to change.
import { toast } from 'react-hot-toast';
import { THEME } from './themeColors';

// Semantic colour for errors — never themed.
const ERROR_RED = '#dc3545';

// Wraps a toast function so it gets theme defaults.
// Anything a page passes itself (style, iconTheme, id...) still wins.
const withDefaults = (fn, defaults) => (message, opts = {}) =>
  fn(message, {
    ...defaults,
    ...opts,
    style: { ...defaults.style, ...opts.style },
  });

// Guard so hot-reload in dev doesn't wrap twice.
if (!toast.__themed) {
  toast.success = withDefaults(toast.success, {
    style: { borderLeft: `4px solid ${THEME.primary}` },
    iconTheme: { primary: THEME.primary, secondary: THEME.onPrimary },
  });

  toast.loading = withDefaults(toast.loading, {
    style: { borderLeft: `4px solid ${THEME.primary}` },
    iconTheme: { primary: THEME.primary, secondary: '#e9ecef' },
  });

  toast.error = withDefaults(toast.error, {
    style: { borderLeft: `4px solid ${ERROR_RED}` },
  });

  toast.__themed = true;
}